import { AlertTriangle } from "lucide-react";

// Renders the bronze-outlined warning shown at the top of any legal page
// that is still in `draft` status — i.e. has not yet been reviewed by a
// licensed attorney.
export function LegalDraftBanner() {
  return (
    <div
      role="status"
      className="mx-auto mb-10 flex max-w-3xl items-start gap-4 border border-bronze-600 bg-bronze-400/10 px-6 py-5"
      style={{ borderRadius: "var(--radius-card, 6px)" }}
    >
      <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-bronze-600" />
      <div>
        <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.22em] text-bronze-600">
          Template — pending attorney review
        </p>
        <p className="mt-2 font-sans text-sm leading-relaxed text-charcoal-900">
          This document is a template pending attorney review. Currency
          Thoughts LLC will replace it with reviewed copy from a licensed
          attorney with insurance and financial services experience before
          launch.
        </p>
      </div>
    </div>
  );
}

export default LegalDraftBanner;